import { render } from "./slider-videos.vue?vue&type=template&id=4db02444&scoped=true&lang=html"
import script from "./slider-videos.vue?vue&type=script&lang=js"
export * from "./slider-videos.vue?vue&type=script&lang=js"

import "./slider-videos.vue?vue&type=style&index=0&id=4db02444&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db02444"]])

export default __exports__